var map = {
	"./": 91762,
	"./aiChatSeeder": 24772,
	"./aiChatSeeder.js": 24772,
	"./aiChatServer": 16671,
	"./aiChatServer.js": 16671,
	"./config": 82022,
	"./config-ncl": 98185,
	"./config-ncl.json": 98185,
	"./config.json": 82022,
	"./data/chat/analyze_cpu": 54427,
	"./data/chat/analyze_cpu.json": 54427,
	"./data/chat/blocked_content": 86746,
	"./data/chat/blocked_content.json": 86746,
	"./data/chat/create_igroup_form": 39058,
	"./data/chat/create_igroup_form.json": 39058,
	"./data/chat/create_vol": 41576,
	"./data/chat/create_vol.json": 41576,
	"./data/chat/delete_vol": 37987,
	"./data/chat/delete_vol.json": 37987,
	"./data/chat/error_api": 38267,
	"./data/chat/error_api.json": 38267,
	"./data/chat/gen_ui_table_charts": 42765,
	"./data/chat/gen_ui_table_charts.json": 42765,
	"./data/chat/welcome": 27283,
	"./data/chat/welcome.json": 27283,
	"./data/keystone/subscriptions": 92071,
	"./data/keystone/subscriptions.json": 92071,
	"./data/keystone/verified-users": 78648,
	"./data/keystone/verified-users.json": 78648,
	"./data/platform-ncl/add-agent-azure": 1952,
	"./data/platform-ncl/add-agent-azure.json": 1952,
	"./data/platform-ncl/add-agent-gcp": 37405,
	"./data/platform-ncl/add-agent-gcp.json": 37405,
	"./data/platform-ncl/add-federation": 14288,
	"./data/platform-ncl/add-federation.json": 14288,
	"./data/platform-ncl/add-pvtjwt-key": 83600,
	"./data/platform-ncl/add-pvtjwt-key.json": 83600,
	"./data/platform-ncl/add-service-account": 87079,
	"./data/platform-ncl/add-service-account.json": 87079,
	"./data/platform-ncl/add-storage-class": 22453,
	"./data/platform-ncl/add-storage-class.json": 22453,
	"./data/platform-ncl/add-user": 57647,
	"./data/platform-ncl/add-user.json": 57647,
	"./data/platform-ncl/add-volume-ncl": 93366,
	"./data/platform-ncl/add-volume-ncl.json": 93366,
	"./data/platform-ncl/adservices-test-connection": 17005,
	"./data/platform-ncl/adservices-test-connection.json": 17005,
	"./data/platform-ncl/agent-create": 2591,
	"./data/platform-ncl/agent-create-azure": 3341,
	"./data/platform-ncl/agent-create-azure.json": 3341,
	"./data/platform-ncl/agent-create.json": 2591,
	"./data/platform-ncl/agent-status": 89762,
	"./data/platform-ncl/agent-status.json": 89762,
	"./data/platform-ncl/ai-config": 41309,
	"./data/platform-ncl/ai-config-id": 68972,
	"./data/platform-ncl/ai-config-id.json": 68972,
	"./data/platform-ncl/ai-config-save": 86292,
	"./data/platform-ncl/ai-config-save.json": 86292,
	"./data/platform-ncl/ai-config.json": 41309,
	"./data/platform-ncl/ai-provider-models": 92057,
	"./data/platform-ncl/ai-provider-models.json": 92057,
	"./data/platform-ncl/ai-supported-models": 28967,
	"./data/platform-ncl/ai-supported-models.json": 28967,
	"./data/platform-ncl/ai-supported-providers": 55356,
	"./data/platform-ncl/ai-supported-providers.json": 55356,
	"./data/platform-ncl/alert-detail": 51227,
	"./data/platform-ncl/alert-detail.json": 51227,
	"./data/platform-ncl/alert-details-timeseries-forecast": 51047,
	"./data/platform-ncl/alert-details-timeseries-forecast.json": 51047,
	"./data/platform-ncl/alert-details-timeseries-history": 94593,
	"./data/platform-ncl/alert-details-timeseries-history.json": 94593,
	"./data/platform-ncl/alert-notification-policies": 57654,
	"./data/platform-ncl/alert-notification-policies.json": 57654,
	"./data/platform-ncl/alert-summary": 2907,
	"./data/platform-ncl/alert-summary.json": 2907,
	"./data/platform-ncl/alert-trends": 73155,
	"./data/platform-ncl/alert-trends.json": 73155,
	"./data/platform-ncl/alerts-agents": 87804,
	"./data/platform-ncl/alerts-agents.json": 87804,
	"./data/platform-ncl/alerts-list": 77040,
	"./data/platform-ncl/alerts-list.json": 77040,
	"./data/platform-ncl/alerts-related": 85411,
	"./data/platform-ncl/alerts-related.json": 85411,
	"./data/platform-ncl/alerts-remediation-options": 52713,
	"./data/platform-ncl/alerts-remediation-options-autogrow": 60589,
	"./data/platform-ncl/alerts-remediation-options-autogrow.json": 60589,
	"./data/platform-ncl/alerts-remediation-options-resize": 31407,
	"./data/platform-ncl/alerts-remediation-options-resize.json": 31407,
	"./data/platform-ncl/alerts-remediation-options.json": 52713,
	"./data/platform-ncl/alerts-remediations": 94833,
	"./data/platform-ncl/alerts-remediations.json": 94833,
	"./data/platform-ncl/alerts-resource-clusteruuid": 39759,
	"./data/platform-ncl/alerts-resource-clusteruuid.json": 39759,
	"./data/platform-ncl/all-relationships": 32974,
	"./data/platform-ncl/all-relationships.json": 32974,
	"./data/platform-ncl/audit": 99120,
	"./data/platform-ncl/audit-options": 66744,
	"./data/platform-ncl/audit-options.json": 66744,
	"./data/platform-ncl/audit.json": 99120,
	"./data/platform-ncl/available-update-versions": 31856,
	"./data/platform-ncl/available-update-versions.json": 31856,
	"./data/platform-ncl/aws-assume-role": 3982,
	"./data/platform-ncl/aws-assume-role.json": 3982,
	"./data/platform-ncl/aws-iam": 44173,
	"./data/platform-ncl/aws-iam.js": 44173,
	"./data/platform-ncl/azure-service-principal-post": 54858,
	"./data/platform-ncl/azure-service-principal-post.json": 54858,
	"./data/platform-ncl/back-up-and-recovery-summary": 67428,
	"./data/platform-ncl/back-up-and-recovery-summary.json": 67428,
	"./data/platform-ncl/billing-preferences": 52042,
	"./data/platform-ncl/billing-preferences.json": 52042,
	"./data/platform-ncl/by-capacity-byol-details-v2": 20508,
	"./data/platform-ncl/by-capacity-byol-details-v2.json": 20508,
	"./data/platform-ncl/capacity-forecast-forecast": 2060,
	"./data/platform-ncl/capacity-forecast-forecast.json": 2060,
	"./data/platform-ncl/capacity-forecast-history": 70941,
	"./data/platform-ncl/capacity-forecast-history.json": 70941,
	"./data/platform-ncl/capacity-percent-timeseries": 55691,
	"./data/platform-ncl/capacity-percent-timeseries.json": 55691,
	"./data/platform-ncl/capacity-timeseries": 29448,
	"./data/platform-ncl/capacity-timeseries.json": 29448,
	"./data/platform-ncl/card-template-aggregate": 34908,
	"./data/platform-ncl/card-template-aggregate.json": 34908,
	"./data/platform-ncl/card-template-fleet": 88735,
	"./data/platform-ncl/card-template-fleet.json": 88735,
	"./data/platform-ncl/card-template-lun": 13268,
	"./data/platform-ncl/card-template-lun.json": 13268,
	"./data/platform-ncl/card-template-svm": 78119,
	"./data/platform-ncl/card-template-svm.json": 78119,
	"./data/platform-ncl/card-template-system": 12825,
	"./data/platform-ncl/card-template-system.json": 12825,
	"./data/platform-ncl/card-template-volume": 18169,
	"./data/platform-ncl/card-template-volume.json": 18169,
	"./data/platform-ncl/case-search": 71131,
	"./data/platform-ncl/case-search.json": 71131,
	"./data/platform-ncl/cbs_we_replication": 77797,
	"./data/platform-ncl/cbs_we_replication.json": 77797,
	"./data/platform-ncl/cbs_we_status": 39218,
	"./data/platform-ncl/cbs_we_status.json": 39218,
	"./data/platform-ncl/cf-events": 49059,
	"./data/platform-ncl/cf-events.js": 49059,
	"./data/platform-ncl/cf-stack": 72135,
	"./data/platform-ncl/cf-stack.js": 72135,
	"./data/platform-ncl/cf-status": 46825,
	"./data/platform-ncl/cf-status.js": 46825,
	"./data/platform-ncl/change-cvo-package-options": 93269,
	"./data/platform-ncl/change-cvo-package-options.json": 93269,
	"./data/platform-ncl/cifs": 88608,
	"./data/platform-ncl/cifs.json": 88608,
	"./data/platform-ncl/cloud-compliance-compliance-status": 38576,
	"./data/platform-ncl/cloud-compliance-compliance-status.json": 38576,
	"./data/platform-ncl/cloud-compliance-status": 28549,
	"./data/platform-ncl/cloud-compliance-status.json": 28549,
	"./data/platform-ncl/cloud-providers": 77784,
	"./data/platform-ncl/cloud-providers.json": 77784,
	"./data/platform-ncl/cloud-storage": 9731,
	"./data/platform-ncl/cloud-storage.json": 9731,
	"./data/platform-ncl/cloud-sync-relationships-stats": 50935,
	"./data/platform-ncl/cloud-sync-relationships-stats.json": 50935,
	"./data/platform-ncl/cloudmanager_cbs-v1-relationships": 50811,
	"./data/platform-ncl/cloudmanager_cbs-v1-relationships.json": 50811,
	"./data/platform-ncl/clusterRecommendation": 35524,
	"./data/platform-ncl/clusterRecommendation.json": 35524,
	"./data/platform-ncl/connector-about": 93767,
	"./data/platform-ncl/connector-about.json": 93767,
	"./data/platform-ncl/connectors": 25616,
	"./data/platform-ncl/connectors.json": 25616,
	"./data/platform-ncl/console-agents-configuration": 5454,
	"./data/platform-ncl/console-agents-configuration.json": 5454,
	"./data/platform-ncl/create-ad-services": 32953,
	"./data/platform-ncl/create-ad-services.json": 32953,
	"./data/platform-ncl/create-folder": 9557,
	"./data/platform-ncl/create-folder.json": 9557,
	"./data/platform-ncl/credential": 60096,
	"./data/platform-ncl/credential.json": 60096,
	"./data/platform-ncl/credentials": 63148,
	"./data/platform-ncl/credentials.json": 63148,
	"./data/platform-ncl/custom-dashboard-details": 66660,
	"./data/platform-ncl/custom-dashboard-details.json": 66660,
	"./data/platform-ncl/custom-dashboard-list": 75913,
	"./data/platform-ncl/custom-dashboard-list.json": 75913,
	"./data/platform-ncl/cvs-azure-accounts": 32608,
	"./data/platform-ncl/cvs-azure-accounts.json": 32608,
	"./data/platform-ncl/disable-adservices": 96716,
	"./data/platform-ncl/disable-adservices.json": 96716,
	"./data/platform-ncl/discover-fsx.json": 25700,
	"./data/platform-ncl/discover-fsx.json.json": 25700,
	"./data/platform-ncl/discover-on-prem": 42716,
	"./data/platform-ncl/discover-on-prem.json": 42716,
	"./data/platform-ncl/dw-associated-accounts": 64290,
	"./data/platform-ncl/dw-associated-accounts.json": 64290,
	"./data/platform-ncl/dw-associated-subscriptions": 87828,
	"./data/platform-ncl/dw-associated-subscriptions.json": 87828,
	"./data/platform-ncl/ec2-keypairs": 9175,
	"./data/platform-ncl/ec2-keypairs.js": 9175,
	"./data/platform-ncl/ec2-status": 33518,
	"./data/platform-ncl/ec2-status.js": 33518,
	"./data/platform-ncl/ec2-subnets": 69829,
	"./data/platform-ncl/ec2-subnets.js": 69829,
	"./data/platform-ncl/ec2-vpcs": 56523,
	"./data/platform-ncl/ec2-vpcs.js": 56523,
	"./data/platform-ncl/email-configuration": 56984,
	"./data/platform-ncl/email-configuration.json": 56984,
	"./data/platform-ncl/enable-adservices.json": 8674,
	"./data/platform-ncl/enable-adservices.json.json": 8674,
	"./data/platform-ncl/external-licenses": 867,
	"./data/platform-ncl/external-licenses.json": 867,
	"./data/platform-ncl/feature-rollouts": 33153,
	"./data/platform-ncl/feature-rollouts.json": 33153,
	"./data/platform-ncl/federation-domains": 2920,
	"./data/platform-ncl/federation-domains-patch": 71076,
	"./data/platform-ncl/federation-domains-patch.json": 71076,
	"./data/platform-ncl/federation-domains-post": 91092,
	"./data/platform-ncl/federation-domains-post.json": 91092,
	"./data/platform-ncl/federation-domains.json": 2920,
	"./data/platform-ncl/federation-test-connection": 52337,
	"./data/platform-ncl/federation-test-connection.json": 52337,
	"./data/platform-ncl/federation-unmigratedconnections": 98334,
	"./data/platform-ncl/federation-unmigratedconnections.json": 98334,
	"./data/platform-ncl/filter-audit-action-add-credentials": 10685,
	"./data/platform-ncl/filter-audit-action-add-credentials.json": 10685,
	"./data/platform-ncl/filter-audit-action-update-license-by-serial": 96871,
	"./data/platform-ncl/filter-audit-action-update-license-by-serial.json": 96871,
	"./data/platform-ncl/filter-audit-action-update-we-snapMirror-policies": 63023,
	"./data/platform-ncl/filter-audit-action-update-we-snapMirror-policies.json": 63023,
	"./data/platform-ncl/filter-audit-no-agent": 18807,
	"./data/platform-ncl/filter-audit-no-agent.json": 18807,
	"./data/platform-ncl/filter-audit-service-console": 4953,
	"./data/platform-ncl/filter-audit-service-console.json": 4953,
	"./data/platform-ncl/filter-audit-service-credentials": 42104,
	"./data/platform-ncl/filter-audit-service-credentials.json": 42104,
	"./data/platform-ncl/filter-audit-service-digitalwallet": 18425,
	"./data/platform-ncl/filter-audit-service-digitalwallet.json": 18425,
	"./data/platform-ncl/filter-audit-status-failed": 20735,
	"./data/platform-ncl/filter-audit-status-failed.json": 20735,
	"./data/platform-ncl/filter-audit-status-success": 71323,
	"./data/platform-ncl/filter-audit-status-success.json": 71323,
	"./data/platform-ncl/filter-audit-user-bill": 9185,
	"./data/platform-ncl/filter-audit-user-bill.json": 9185,
	"./data/platform-ncl/filter-audit-user-sam": 35664,
	"./data/platform-ncl/filter-audit-user-sam.json": 35664,
	"./data/platform-ncl/filter-backup-licenses": 81875,
	"./data/platform-ncl/filter-backup-licenses.json": 81875,
	"./data/platform-ncl/filter-dr-licenses": 94359,
	"./data/platform-ncl/filter-dr-licenses.json": 94359,
	"./data/platform-ncl/filter-include-exchanged-licenses": 63990,
	"./data/platform-ncl/filter-include-exchanged-licenses.json": 63990,
	"./data/platform-ncl/filter-org-resources-count": 96314,
	"./data/platform-ncl/filter-org-resources-count.json": 96314,
	"./data/platform-ncl/filter-rsp-licenses": 68906,
	"./data/platform-ncl/filter-rsp-licenses.json": 68906,
	"./data/platform-ncl/filter-tiering-licenses": 55097,
	"./data/platform-ncl/filter-tiering-licenses.json": 55097,
	"./data/platform-ncl/fleet-aggregates": 79512,
	"./data/platform-ncl/fleet-aggregates.json": 79512,
	"./data/platform-ncl/fleet-clusters": 11730,
	"./data/platform-ncl/fleet-clusters-certificateExpiryStatus": 56330,
	"./data/platform-ncl/fleet-clusters-certificateExpiryStatus.json": 56330,
	"./data/platform-ncl/fleet-clusters.json": 11730,
	"./data/platform-ncl/fleet-detail": 12388,
	"./data/platform-ncl/fleet-detail.json": 12388,
	"./data/platform-ncl/fleet-luns": 6435,
	"./data/platform-ncl/fleet-luns.json": 6435,
	"./data/platform-ncl/fleet-management-detail": 80466,
	"./data/platform-ncl/fleet-management-detail.json": 80466,
	"./data/platform-ncl/fleet-nodes": 14903,
	"./data/platform-ncl/fleet-nodes.json": 14903,
	"./data/platform-ncl/fleet-svms": 83287,
	"./data/platform-ncl/fleet-svms.json": 83287,
	"./data/platform-ncl/fleet-volumes": 30436,
	"./data/platform-ncl/fleet-volumes.json": 30436,
	"./data/platform-ncl/fleets": 64800,
	"./data/platform-ncl/fleets.json": 64800,
	"./data/platform-ncl/folder-resources-get": 95960,
	"./data/platform-ncl/folder-resources-get.json": 95960,
	"./data/platform-ncl/gcp-agent-create": 6710,
	"./data/platform-ncl/gcp-agent-create.json": 6710,
	"./data/platform-ncl/gcp-config-deployment": 27609,
	"./data/platform-ncl/gcp-config-deployment.json": 27609,
	"./data/platform-ncl/gcp-config-operation-status": 52246,
	"./data/platform-ncl/gcp-config-operation-status.json": 52246,
	"./data/platform-ncl/gcp-storage-buckets": 9092,
	"./data/platform-ncl/gcp-storage-buckets.json": 9092,
	"./data/platform-ncl/gcp-storage-upload-object": 90081,
	"./data/platform-ncl/gcp-storage-upload-object.json": 90081,
	"./data/platform-ncl/get-ad-services": 66448,
	"./data/platform-ncl/get-ad-services.json": 66448,
	"./data/platform-ncl/get-agent": 66456,
	"./data/platform-ncl/get-agent.json": 66456,
	"./data/platform-ncl/get-capacity-policies": 16716,
	"./data/platform-ncl/get-capacity-policies.json": 16716,
	"./data/platform-ncl/get-export-policies": 52874,
	"./data/platform-ncl/get-export-policies.json": 52874,
	"./data/platform-ncl/get-igroups": 5791,
	"./data/platform-ncl/get-igroups.json": 5791,
	"./data/platform-ncl/get-initiators": 18397,
	"./data/platform-ncl/get-initiators.json": 18397,
	"./data/platform-ncl/get-local-tiers-by-org": 62525,
	"./data/platform-ncl/get-local-tiers-by-org.json": 62525,
	"./data/platform-ncl/get-luns-by-org": 7358,
	"./data/platform-ncl/get-luns-by-org.json": 7358,
	"./data/platform-ncl/get-os-types": 10305,
	"./data/platform-ncl/get-os-types.json": 10305,
	"./data/platform-ncl/get-performance-policies": 80022,
	"./data/platform-ncl/get-performance-policies.json": 80022,
	"./data/platform-ncl/get-protection-policies": 111,
	"./data/platform-ncl/get-protection-policies.json": 111,
	"./data/platform-ncl/get-pvtjwt-keys": 5605,
	"./data/platform-ncl/get-pvtjwt-keys.json": 5605,
	"./data/platform-ncl/get-security-policies": 33169,
	"./data/platform-ncl/get-security-policies.json": 33169,
	"./data/platform-ncl/get-serviceAccount": 64370,
	"./data/platform-ncl/get-serviceAccount.json": 64370,
	"./data/platform-ncl/get-storage-class": 97979,
	"./data/platform-ncl/get-storage-class.json": 97979,
	"./data/platform-ncl/get-storage-classes": 28844,
	"./data/platform-ncl/get-storage-classes.json": 28844,
	"./data/platform-ncl/get-storage-performance": 32934,
	"./data/platform-ncl/get-storage-performance.json": 32934,
	"./data/platform-ncl/get-svm-list": 21917,
	"./data/platform-ncl/get-svm-list.json": 21917,
	"./data/platform-ncl/get-svms-by-org": 29346,
	"./data/platform-ncl/get-svms-by-org.json": 29346,
	"./data/platform-ncl/get-system-recommendations": 90885,
	"./data/platform-ncl/get-system-recommendations.json": 90885,
	"./data/platform-ncl/get-systems-by-org": 88971,
	"./data/platform-ncl/get-systems-by-org.json": 88971,
	"./data/platform-ncl/get-volumes-by-org": 2642,
	"./data/platform-ncl/get-volumes-by-org.json": 2642,
	"./data/platform-ncl/get-working-environments-relationship-status": 43191,
	"./data/platform-ncl/get-working-environments-relationship-status.json": 43191,
	"./data/platform-ncl/get-working-environments-status": 21077,
	"./data/platform-ncl/get-working-environments-status.json": 21077,
	"./data/platform-ncl/google-service-accounts-deployments": 89172,
	"./data/platform-ncl/google-service-accounts-deployments-status": 24853,
	"./data/platform-ncl/google-service-accounts-deployments-status.json": 24853,
	"./data/platform-ncl/google-service-accounts-deployments.json": 89172,
	"./data/platform-ncl/google-service-accounts-firewalls-post": 12047,
	"./data/platform-ncl/google-service-accounts-firewalls-post.json": 12047,
	"./data/platform-ncl/google-service-accounts-instances": 61798,
	"./data/platform-ncl/google-service-accounts-instances.json": 61798,
	"./data/platform-ncl/google-service-console-agents-configuration": 36728,
	"./data/platform-ncl/google-service-console-agents-configuration.json": 36728,
	"./data/platform-ncl/google-service-template-json": 44150,
	"./data/platform-ncl/google-service-template-json.json": 44150,
	"./data/platform-ncl/health-status-timeseries": 22094,
	"./data/platform-ncl/health-status-timeseries.json": 22094,
	"./data/platform-ncl/igroups": 19767,
	"./data/platform-ncl/igroups.json": 19767,
	"./data/platform-ncl/initiators": 22813,
	"./data/platform-ncl/initiators.json": 22813,
	"./data/platform-ncl/iops-timeseries": 25061,
	"./data/platform-ncl/iops-timeseries.json": 25061,
	"./data/platform-ncl/kms": 63500,
	"./data/platform-ncl/kms.json": 63500,
	"./data/platform-ncl/latency-timeseries": 1872,
	"./data/platform-ncl/latency-timeseries.json": 1872,
	"./data/platform-ncl/license-summary": 69205,
	"./data/platform-ncl/license-summary.json": 69205,
	"./data/platform-ncl/licenses": 6616,
	"./data/platform-ncl/licenses.json": 6616,
	"./data/platform-ncl/max-latency-overtime": 79188,
	"./data/platform-ncl/max-latency-overtime.json": 79188,
	"./data/platform-ncl/mfa-device-create": 32980,
	"./data/platform-ncl/mfa-device-create.json": 32980,
	"./data/platform-ncl/mfa-devices": 51665,
	"./data/platform-ncl/mfa-devices.json": 51665,
	"./data/platform-ncl/mfa-oauth-token": 69463,
	"./data/platform-ncl/mfa-oauth-token.json": 69463,
	"./data/platform-ncl/mfa-recovery-code": 37120,
	"./data/platform-ncl/mfa-recovery-code-status": 49641,
	"./data/platform-ncl/mfa-recovery-code-status.json": 49641,
	"./data/platform-ncl/mfa-recovery-code.json": 37120,
	"./data/platform-ncl/mfa-register": 64374,
	"./data/platform-ncl/mfa-register.json": 64374,
	"./data/platform-ncl/mfa-user-config-status": 95092,
	"./data/platform-ncl/mfa-user-config-status.json": 95092,
	"./data/platform-ncl/notification-config": 63785,
	"./data/platform-ncl/notification-config.json": 63785,
	"./data/platform-ncl/notification-messages": 72762,
	"./data/platform-ncl/notification-messages.json": 72762,
	"./data/platform-ncl/notification-rule": 83585,
	"./data/platform-ncl/notification-rule.json": 83585,
	"./data/platform-ncl/notification-rules": 20100,
	"./data/platform-ncl/notification-rules.json": 20100,
	"./data/platform-ncl/notifications": 9195,
	"./data/platform-ncl/notifications.json": 9195,
	"./data/platform-ncl/nss-keys": 82603,
	"./data/platform-ncl/nss-keys.json": 82603,
	"./data/platform-ncl/occm-asup": 89072,
	"./data/platform-ncl/occm-asup.json": 89072,
	"./data/platform-ncl/occm-config": 32325,
	"./data/platform-ncl/occm-config.json": 32325,
	"./data/platform-ncl/occm-instance-placement": 46652,
	"./data/platform-ncl/occm-instance-placement.json": 46652,
	"./data/platform-ncl/occmauth-api-users": 34291,
	"./data/platform-ncl/occmauth-api-users.json": 34291,
	"./data/platform-ncl/onbox-credentials": 4973,
	"./data/platform-ncl/onbox-credentials.json": 4973,
	"./data/platform-ncl/onprem-aggregates": 16345,
	"./data/platform-ncl/onprem-aggregates.json": 16345,
	"./data/platform-ncl/onprem-replication-status": 55242,
	"./data/platform-ncl/onprem-replication-status.json": 55242,
	"./data/platform-ncl/onprem-volumes": 76487,
	"./data/platform-ncl/onprem-volumes.json": 76487,
	"./data/platform-ncl/onprem-working-environment-details": 12756,
	"./data/platform-ncl/onprem-working-environment-details.json": 12756,
	"./data/platform-ncl/org1-get": 42312,
	"./data/platform-ncl/org1-get.json": 42312,
	"./data/platform-ncl/organization-delete-users": 31412,
	"./data/platform-ncl/organization-delete-users.json": 31412,
	"./data/platform-ncl/organization-summary": 46780,
	"./data/platform-ncl/organization-summary.json": 46780,
	"./data/platform-ncl/orgs": 75612,
	"./data/platform-ncl/orgs.json": 75612,
	"./data/platform-ncl/partnership": 48557,
	"./data/platform-ncl/partnership-grant-resources": 58969,
	"./data/platform-ncl/partnership-grant-resources.json": 58969,
	"./data/platform-ncl/partnership-grant-users": 98844,
	"./data/platform-ncl/partnership-grant-users.json": 98844,
	"./data/platform-ncl/partnership-grants": 66502,
	"./data/platform-ncl/partnership-grants.json": 66502,
	"./data/platform-ncl/partnership-organizations": 76046,
	"./data/platform-ncl/partnership-organizations.json": 76046,
	"./data/platform-ncl/partnership-users": 96346,
	"./data/platform-ncl/partnership-users.json": 96346,
	"./data/platform-ncl/partnership.json": 48557,
	"./data/platform-ncl/partnerships": 21770,
	"./data/platform-ncl/partnerships.json": 21770,
	"./data/platform-ncl/partnershiptypes": 40185,
	"./data/platform-ncl/partnershiptypes.json": 40185,
	"./data/platform-ncl/performance-capacity-timeseries": 28574,
	"./data/platform-ncl/performance-capacity-timeseries.json": 28574,
	"./data/platform-ncl/permissions": 79383,
	"./data/platform-ncl/permissions.json": 79383,
	"./data/platform-ncl/permissions_full": 9762,
	"./data/platform-ncl/permissions_full.json": 9762,
	"./data/platform-ncl/projects-resources": 79392,
	"./data/platform-ncl/projects-resources-aws": 6843,
	"./data/platform-ncl/projects-resources-aws.json": 6843,
	"./data/platform-ncl/projects-resources-azure": 29464,
	"./data/platform-ncl/projects-resources-azure.json": 29464,
	"./data/platform-ncl/projects-resources-gcp": 93168,
	"./data/platform-ncl/projects-resources-gcp.json": 93168,
	"./data/platform-ncl/projects-resources-keystone": 99971,
	"./data/platform-ncl/projects-resources-keystone.json": 99971,
	"./data/platform-ncl/projects-resources-onprem": 37083,
	"./data/platform-ncl/projects-resources-onprem.json": 37083,
	"./data/platform-ncl/projects-resources.json": 79392,
	"./data/platform-ncl/ransomware-status": 55776,
	"./data/platform-ncl/ransomware-status.json": 55776,
	"./data/platform-ncl/ransomware-summary": 4218,
	"./data/platform-ncl/ransomware-summary.json": 4218,
	"./data/platform-ncl/registration-status": 95184,
	"./data/platform-ncl/registration-status.json": 95184,
	"./data/platform-ncl/resource-apac-get": 34346,
	"./data/platform-ncl/resource-apac-get.json": 34346,
	"./data/platform-ncl/resource-utilization-aggr-forecast": 58070,
	"./data/platform-ncl/resource-utilization-aggr-forecast.json": 58070,
	"./data/platform-ncl/resource-utilization-aggr-history": 46726,
	"./data/platform-ncl/resource-utilization-aggr-history.json": 46726,
	"./data/platform-ncl/resource-utilization-node-forecast": 77864,
	"./data/platform-ncl/resource-utilization-node-forecast.json": 77864,
	"./data/platform-ncl/resource-utilization-node-history": 51431,
	"./data/platform-ncl/resource-utilization-node-history.json": 51431,
	"./data/platform-ncl/resources": 12985,
	"./data/platform-ncl/resources.json": 12985,
	"./data/platform-ncl/roles": 76812,
	"./data/platform-ncl/roles.json": 76812,
	"./data/platform-ncl/s3": 46659,
	"./data/platform-ncl/s3.json": 46659,
	"./data/platform-ncl/saas-mp-service": 85666,
	"./data/platform-ncl/saas-mp-service.json": 85666,
	"./data/platform-ncl/self-certificate": 84211,
	"./data/platform-ncl/self-certificate.json": 84211,
	"./data/platform-ncl/settings-proxy": 98437,
	"./data/platform-ncl/settings-proxy.json": 98437,
	"./data/platform-ncl/signed-certificate": 40091,
	"./data/platform-ncl/signed-certificate.json": 40091,
	"./data/platform-ncl/snapcenter_clusters": 67881,
	"./data/platform-ncl/snapcenter_clusters.json": 67881,
	"./data/platform-ncl/snapshot-get": 70427,
	"./data/platform-ncl/snapshot-get.json": 70427,
	"./data/platform-ncl/storageAccounts": 65194,
	"./data/platform-ncl/storageAccounts.json": 65194,
	"./data/platform-ncl/subscriptions": 48923,
	"./data/platform-ncl/subscriptions.json": 48923,
	"./data/platform-ncl/support-services": 83729,
	"./data/platform-ncl/support-services.json": 83729,
	"./data/platform-ncl/system-about": 93338,
	"./data/platform-ncl/system-about.json": 93338,
	"./data/platform-ncl/tenancy-resources": 12888,
	"./data/platform-ncl/tenancy-resources.json": 12888,
	"./data/platform-ncl/throughput-timeseries": 99158,
	"./data/platform-ncl/throughput-timeseries.json": 99158,
	"./data/platform-ncl/tiering": 4465,
	"./data/platform-ncl/tiering.json": 4465,
	"./data/platform-ncl/uiroles": 76782,
	"./data/platform-ncl/uiroles.json": 76782,
	"./data/platform-ncl/user-details": 28421,
	"./data/platform-ncl/user-details.json": 28421,
	"./data/platform-ncl/user-details_full": 64250,
	"./data/platform-ncl/user-details_full.json": 64250,
	"./data/platform-ncl/user-login-tracking": 8654,
	"./data/platform-ncl/user-login-tracking.json": 8654,
	"./data/platform-ncl/user-permissions-resources": 78433,
	"./data/platform-ncl/user-permissions-resources.json": 78433,
	"./data/platform-ncl/user-preferences-app-preferences": 1242,
	"./data/platform-ncl/user-preferences-app-preferences.json": 1242,
	"./data/platform-ncl/user-preferences-splashscreen-v-1-dismissed": 18546,
	"./data/platform-ncl/user-preferences-splashscreen-v-1-dismissed.json": 18546,
	"./data/platform-ncl/user-resources-elevated-permissions": 90241,
	"./data/platform-ncl/user-resources-elevated-permissions.json": 90241,
	"./data/platform-ncl/user-resources-permissions": 29127,
	"./data/platform-ncl/user-resources-permissions.json": 29127,
	"./data/platform-ncl/users": 89376,
	"./data/platform-ncl/users-filter-service-account": 4808,
	"./data/platform-ncl/users-filter-service-account.json": 4808,
	"./data/platform-ncl/users-filter-total-users": 82754,
	"./data/platform-ncl/users-filter-total-users.json": 82754,
	"./data/platform-ncl/users.json": 89376,
	"./data/platform-ncl/utilization-timeseries": 85258,
	"./data/platform-ncl/utilization-timeseries.json": 85258,
	"./data/platform-ncl/view-volume-details": 98599,
	"./data/platform-ncl/view-volume-details.json": 98599,
	"./data/platform-ncl/volume-avg-latency": 82262,
	"./data/platform-ncl/volume-avg-latency.json": 82262,
	"./data/platform-ncl/volume-other-latency": 24347,
	"./data/platform-ncl/volume-other-latency.json": 24347,
	"./data/platform-ncl/volume-other-ops": 17557,
	"./data/platform-ncl/volume-other-ops.json": 17557,
	"./data/platform-ncl/volume-read-data": 84262,
	"./data/platform-ncl/volume-read-data.json": 84262,
	"./data/platform-ncl/volume-read-latency": 10331,
	"./data/platform-ncl/volume-read-latency.json": 10331,
	"./data/platform-ncl/volume-read-ops": 15966,
	"./data/platform-ncl/volume-read-ops.json": 15966,
	"./data/platform-ncl/volume-total-data": 7387,
	"./data/platform-ncl/volume-total-data.json": 7387,
	"./data/platform-ncl/volume-total-ops": 72795,
	"./data/platform-ncl/volume-total-ops.json": 72795,
	"./data/platform-ncl/volume-write-data": 95874,
	"./data/platform-ncl/volume-write-data.json": 95874,
	"./data/platform-ncl/volume-write-latency": 1490,
	"./data/platform-ncl/volume-write-latency.json": 1490,
	"./data/platform-ncl/volume-write-ops": 76212,
	"./data/platform-ncl/volume-write-ops.json": 76212,
	"./data/platform-ncl/webhook-configuration": 87770,
	"./data/platform-ncl/webhook-configuration.json": 87770,
	"./data/platform-ncl/webhook-configurations": 9283,
	"./data/platform-ncl/webhook-configurations.json": 9283,
	"./data/platform-ncl/working-environments": 27808,
	"./data/platform-ncl/working-environments-performance": 99404,
	"./data/platform-ncl/working-environments-performance.json": 99404,
	"./data/platform-ncl/working-environments.json": 27808,
	"./data/platform-ncl/workload-analyzer-timeseries-available-forecast": 17700,
	"./data/platform-ncl/workload-analyzer-timeseries-available-forecast.json": 17700,
	"./data/platform-ncl/workload-analyzer-timeseries-available-history": 71525,
	"./data/platform-ncl/workload-analyzer-timeseries-available-history.json": 71525,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-reserve-forecast": 5978,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-reserve-forecast.json": 5978,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-reserve-history": 76395,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-reserve-history.json": 76395,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-used-forecast": 80338,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-used-forecast.json": 80338,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-used-history": 17475,
	"./data/platform-ncl/workload-analyzer-timeseries-snapshot-used-history.json": 17475,
	"./data/platform-ncl/workload-analyzer-timeseries-used-forecast": 56679,
	"./data/platform-ncl/workload-analyzer-timeseries-used-forecast.json": 56679,
	"./data/platform-ncl/workload-analyzer-timeseries-used-history": 64030,
	"./data/platform-ncl/workload-analyzer-timeseries-used-history.json": 64030,
	"./data/platform/add-agent-azure": 49290,
	"./data/platform/add-agent-azure.json": 49290,
	"./data/platform/add-agent-gcp": 98395,
	"./data/platform/add-agent-gcp.json": 98395,
	"./data/platform/add-federation": 1034,
	"./data/platform/add-federation.json": 1034,
	"./data/platform/add-pvtjwt-key": 29066,
	"./data/platform/add-pvtjwt-key.json": 29066,
	"./data/platform/add-service-account": 64712,
	"./data/platform/add-service-account.json": 64712,
	"./data/platform/add-storage-class": 27706,
	"./data/platform/add-storage-class.json": 27706,
	"./data/platform/add-user": 64878,
	"./data/platform/add-user.json": 64878,
	"./data/platform/agent-create": 13660,
	"./data/platform/agent-create-azure": 98854,
	"./data/platform/agent-create-azure.json": 98854,
	"./data/platform/agent-create.json": 13660,
	"./data/platform/agent-status": 60692,
	"./data/platform/agent-status.json": 60692,
	"./data/platform/ai-config": 69866,
	"./data/platform/ai-config-id": 30997,
	"./data/platform/ai-config-id.json": 30997,
	"./data/platform/ai-config-save": 17079,
	"./data/platform/ai-config-save.json": 17079,
	"./data/platform/ai-config.json": 69866,
	"./data/platform/ai-provider-models": 11187,
	"./data/platform/ai-provider-models.json": 11187,
	"./data/platform/ai-supported-models": 15174,
	"./data/platform/ai-supported-models.json": 15174,
	"./data/platform/ai-supported-providers": 8245,
	"./data/platform/ai-supported-providers.json": 8245,
	"./data/platform/alert-detail": 94726,
	"./data/platform/alert-detail.json": 94726,
	"./data/platform/alert-summary": 60206,
	"./data/platform/alert-summary.json": 60206,
	"./data/platform/alert-trends": 60762,
	"./data/platform/alert-trends.json": 60762,
	"./data/platform/alerts-agents": 62744,
	"./data/platform/alerts-agents.json": 62744,
	"./data/platform/alerts-list": 20689,
	"./data/platform/alerts-list.json": 20689,
	"./data/platform/alerts-related": 8732,
	"./data/platform/alerts-related.json": 8732,
	"./data/platform/all-relationships": 91906,
	"./data/platform/all-relationships.json": 91906,
	"./data/platform/audit": 90337,
	"./data/platform/audit-options": 38775,
	"./data/platform/audit-options.json": 38775,
	"./data/platform/audit.json": 90337,
	"./data/platform/available-update-versions": 32993,
	"./data/platform/available-update-versions.json": 32993,
	"./data/platform/aws-assume-role": 4399,
	"./data/platform/aws-assume-role.json": 4399,
	"./data/platform/aws-iam": 16798,
	"./data/platform/aws-iam.js": 16798,
	"./data/platform/azure-service-principal-post": 58071,
	"./data/platform/azure-service-principal-post.json": 58071,
	"./data/platform/back-up-and-recovery-summary": 13295,
	"./data/platform/back-up-and-recovery-summary.json": 13295,
	"./data/platform/billing-preferences": 45750,
	"./data/platform/billing-preferences.json": 45750,
	"./data/platform/by-capacity-byol-details-v2": 85792,
	"./data/platform/by-capacity-byol-details-v2.json": 85792,
	"./data/platform/case-search": 67828,
	"./data/platform/case-search.json": 67828,
	"./data/platform/cbs_we_replication": 86602,
	"./data/platform/cbs_we_replication.json": 86602,
	"./data/platform/cbs_we_status": 38975,
	"./data/platform/cbs_we_status.json": 38975,
	"./data/platform/cf-events": 6851,
	"./data/platform/cf-events.js": 6851,
	"./data/platform/cf-stack": 44535,
	"./data/platform/cf-stack.js": 44535,
	"./data/platform/cf-status": 59912,
	"./data/platform/cf-status.js": 59912,
	"./data/platform/change-cvo-package-options": 12153,
	"./data/platform/change-cvo-package-options.json": 12153,
	"./data/platform/cifs": 95416,
	"./data/platform/cifs.json": 95416,
	"./data/platform/cloud-compliance-compliance-status": 49515,
	"./data/platform/cloud-compliance-compliance-status.json": 49515,
	"./data/platform/cloud-compliance-status": 70590,
	"./data/platform/cloud-compliance-status.json": 70590,
	"./data/platform/cloud-providers": 41230,
	"./data/platform/cloud-providers.json": 41230,
	"./data/platform/cloud-storage": 27668,
	"./data/platform/cloud-storage.json": 27668,
	"./data/platform/cloud-sync-relationships-stats": 41638,
	"./data/platform/cloud-sync-relationships-stats.json": 41638,
	"./data/platform/cloudmanager_cbs-v1-relationships": 119,
	"./data/platform/cloudmanager_cbs-v1-relationships.json": 119,
	"./data/platform/clusterRecommendation": 96626,
	"./data/platform/clusterRecommendation.json": 96626,
	"./data/platform/connector-about": 27235,
	"./data/platform/connector-about.json": 27235,
	"./data/platform/connectors": 30930,
	"./data/platform/connectors.json": 30930,
	"./data/platform/console-agents-configuration": 88263,
	"./data/platform/console-agents-configuration.json": 88263,
	"./data/platform/create-folder": 51090,
	"./data/platform/create-folder.json": 51090,
	"./data/platform/credential": 2682,
	"./data/platform/credential.json": 2682,
	"./data/platform/credentials": 77216,
	"./data/platform/credentials.json": 77216,
	"./data/platform/cvs-azure-accounts": 69947,
	"./data/platform/cvs-azure-accounts.json": 69947,
	"./data/platform/discover-fsx.json": 94207,
	"./data/platform/discover-fsx.json.json": 94207,
	"./data/platform/discover-on-prem": 66271,
	"./data/platform/discover-on-prem.json": 66271,
	"./data/platform/dw-associated-accounts": 54161,
	"./data/platform/dw-associated-accounts.json": 54161,
	"./data/platform/dw-associated-subscriptions": 78285,
	"./data/platform/dw-associated-subscriptions.json": 78285,
	"./data/platform/ec2-keypairs": 50938,
	"./data/platform/ec2-keypairs.js": 50938,
	"./data/platform/ec2-status": 78661,
	"./data/platform/ec2-status.js": 78661,
	"./data/platform/ec2-subnets": 48204,
	"./data/platform/ec2-subnets.js": 48204,
	"./data/platform/ec2-vpcs": 97376,
	"./data/platform/ec2-vpcs.js": 97376,
	"./data/platform/external-licenses": 74142,
	"./data/platform/external-licenses.json": 74142,
	"./data/platform/feature-rollouts": 60215,
	"./data/platform/feature-rollouts.json": 60215,
	"./data/platform/federation-domains": 83806,
	"./data/platform/federation-domains-patch": 13822,
	"./data/platform/federation-domains-patch.json": 13822,
	"./data/platform/federation-domains-post": 8789,
	"./data/platform/federation-domains-post.json": 8789,
	"./data/platform/federation-domains.json": 83806,
	"./data/platform/federation-federations": 85224,
	"./data/platform/federation-federations.json": 85224,
	"./data/platform/federation-test-connection": 71386,
	"./data/platform/federation-test-connection.json": 71386,
	"./data/platform/federation-unmigratedconnections": 70058,
	"./data/platform/federation-unmigratedconnections.json": 70058,
	"./data/platform/filter-audit-action-add-credentials": 3907,
	"./data/platform/filter-audit-action-add-credentials.json": 3907,
	"./data/platform/filter-audit-action-update-license-by-serial": 48093,
	"./data/platform/filter-audit-action-update-license-by-serial.json": 48093,
	"./data/platform/filter-audit-action-update-we-snapMirror-policies": 91500,
	"./data/platform/filter-audit-action-update-we-snapMirror-policies.json": 91500,
	"./data/platform/filter-audit-no-agent": 33928,
	"./data/platform/filter-audit-no-agent.json": 33928,
	"./data/platform/filter-audit-service-console": 59194,
	"./data/platform/filter-audit-service-console.json": 59194,
	"./data/platform/filter-audit-service-credentials": 63857,
	"./data/platform/filter-audit-service-credentials.json": 63857,
	"./data/platform/filter-audit-service-digitalwallet": 21666,
	"./data/platform/filter-audit-service-digitalwallet.json": 21666,
	"./data/platform/filter-audit-status-failed": 1864,
	"./data/platform/filter-audit-status-failed.json": 1864,
	"./data/platform/filter-audit-status-success": 68954,
	"./data/platform/filter-audit-status-success.json": 68954,
	"./data/platform/filter-audit-user-bill": 79907,
	"./data/platform/filter-audit-user-bill.json": 79907,
	"./data/platform/filter-audit-user-sam": 41702,
	"./data/platform/filter-audit-user-sam.json": 41702,
	"./data/platform/filter-backup-licenses": 31996,
	"./data/platform/filter-backup-licenses.json": 31996,
	"./data/platform/filter-dr-licenses": 76807,
	"./data/platform/filter-dr-licenses.json": 76807,
	"./data/platform/filter-include-exchanged-licenses": 72411,
	"./data/platform/filter-include-exchanged-licenses.json": 72411,
	"./data/platform/filter-org-resources-count": 34910,
	"./data/platform/filter-org-resources-count.json": 34910,
	"./data/platform/filter-org-users": 61216,
	"./data/platform/filter-org-users.json": 61216,
	"./data/platform/filter-rsp-licenses": 12408,
	"./data/platform/filter-rsp-licenses.json": 12408,
	"./data/platform/filter-tiering-licenses": 35401,
	"./data/platform/filter-tiering-licenses.json": 35401,
	"./data/platform/folder-resources-get": 58349,
	"./data/platform/folder-resources-get.json": 58349,
	"./data/platform/gcp-agent-create": 5189,
	"./data/platform/gcp-agent-create.json": 5189,
	"./data/platform/gcp-config-deployment": 38422,
	"./data/platform/gcp-config-deployment.json": 38422,
	"./data/platform/gcp-config-operation-status": 63449,
	"./data/platform/gcp-config-operation-status.json": 63449,
	"./data/platform/gcp-storage-buckets": 96539,
	"./data/platform/gcp-storage-buckets.json": 96539,
	"./data/platform/gcp-storage-upload-object": 17341,
	"./data/platform/gcp-storage-upload-object.json": 17341,
	"./data/platform/get-agent": 38175,
	"./data/platform/get-agent.json": 38175,
	"./data/platform/get-capacity-policies": 28241,
	"./data/platform/get-capacity-policies.json": 28241,
	"./data/platform/get-export-policies": 29555,
	"./data/platform/get-export-policies.json": 29555,
	"./data/platform/get-igroups": 83554,
	"./data/platform/get-igroups.json": 83554,
	"./data/platform/get-initiators": 53403,
	"./data/platform/get-initiators.json": 53403,
	"./data/platform/get-os-types": 6310,
	"./data/platform/get-os-types.json": 6310,
	"./data/platform/get-performance-policies": 76116,
	"./data/platform/get-performance-policies.json": 76116,
	"./data/platform/get-protection-policies": 37431,
	"./data/platform/get-protection-policies.json": 37431,
	"./data/platform/get-pvtjwt-keys": 14450,
	"./data/platform/get-pvtjwt-keys.json": 14450,
	"./data/platform/get-security-policies": 99714,
	"./data/platform/get-security-policies.json": 99714,
	"./data/platform/get-serviceAccount": 75435,
	"./data/platform/get-serviceAccount.json": 75435,
	"./data/platform/get-storage-class": 16393,
	"./data/platform/get-storage-class.json": 16393,
	"./data/platform/get-storage-classes": 25082,
	"./data/platform/get-storage-classes.json": 25082,
	"./data/platform/get-storage-performance": 69391,
	"./data/platform/get-storage-performance.json": 69391,
	"./data/platform/get-system-recommendations": 54315,
	"./data/platform/get-system-recommendations.json": 54315,
	"./data/platform/get-working-environments-relationship-status": 49549,
	"./data/platform/get-working-environments-relationship-status.json": 49549,
	"./data/platform/get-working-environments-status": 8741,
	"./data/platform/get-working-environments-status.json": 8741,
	"./data/platform/google-service-accounts-deployments": 99179,
	"./data/platform/google-service-accounts-deployments-status": 72040,
	"./data/platform/google-service-accounts-deployments-status.json": 72040,
	"./data/platform/google-service-accounts-deployments.json": 99179,
	"./data/platform/google-service-accounts-firewalls-post": 97017,
	"./data/platform/google-service-accounts-firewalls-post.json": 97017,
	"./data/platform/google-service-accounts-instances": 39913,
	"./data/platform/google-service-accounts-instances.json": 39913,
	"./data/platform/google-service-console-agents-configuration": 10171,
	"./data/platform/google-service-console-agents-configuration.json": 10171,
	"./data/platform/google-service-template-json": 45318,
	"./data/platform/google-service-template-json.json": 45318,
	"./data/platform/igroups": 50452,
	"./data/platform/igroups.json": 50452,
	"./data/platform/initiators": 66526,
	"./data/platform/initiators.json": 66526,
	"./data/platform/kms": 45631,
	"./data/platform/kms-us-east-2": 37229,
	"./data/platform/kms-us-east-2.json": 37229,
	"./data/platform/kms-us-west-1": 75221,
	"./data/platform/kms-us-west-1.json": 75221,
	"./data/platform/kms.json": 45631,
	"./data/platform/license-summary": 87234,
	"./data/platform/license-summary.json": 87234,
	"./data/platform/licenses": 50824,
	"./data/platform/licenses.json": 50824,
	"./data/platform/notification-config": 49894,
	"./data/platform/notification-config.json": 49894,
	"./data/platform/notification-messages": 58473,
	"./data/platform/notification-messages.json": 58473,
	"./data/platform/notifications": 576,
	"./data/platform/notifications.json": 576,
	"./data/platform/nss-keys": 29903,
	"./data/platform/nss-keys.json": 29903,
	"./data/platform/occm-asup": 18456,
	"./data/platform/occm-asup.json": 18456,
	"./data/platform/occm-config": 44251,
	"./data/platform/occm-config.json": 44251,
	"./data/platform/occm-instance-placement": 88927,
	"./data/platform/occm-instance-placement.json": 88927,
	"./data/platform/occmauth-api-users": 76546,
	"./data/platform/occmauth-api-users.json": 76546,
	"./data/platform/onbox-credentials": 28138,
	"./data/platform/onbox-credentials.json": 28138,
	"./data/platform/onprem-aggregates": 4972,
	"./data/platform/onprem-aggregates.json": 4972,
	"./data/platform/onprem-cluster-info": 40639,
	"./data/platform/onprem-cluster-info.json": 40639,
	"./data/platform/onprem-replication-status": 88153,
	"./data/platform/onprem-replication-status.json": 88153,
	"./data/platform/onprem-volumes": 19463,
	"./data/platform/onprem-volumes.json": 19463,
	"./data/platform/onprem-working-environment-details": 90,
	"./data/platform/onprem-working-environment-details.json": 90,
	"./data/platform/org1-get": 14670,
	"./data/platform/org1-get.json": 14670,
	"./data/platform/organization-delete-users": 92781,
	"./data/platform/organization-delete-users.json": 92781,
	"./data/platform/organization-summary": 41256,
	"./data/platform/organization-summary.json": 41256,
	"./data/platform/orgs": 22357,
	"./data/platform/orgs.json": 22357,
	"./data/platform/partnership": 86259,
	"./data/platform/partnership-grant-resources": 13682,
	"./data/platform/partnership-grant-resources.json": 13682,
	"./data/platform/partnership-grant-users": 94247,
	"./data/platform/partnership-grant-users.json": 94247,
	"./data/platform/partnership-grants": 59050,
	"./data/platform/partnership-grants.json": 59050,
	"./data/platform/partnership-organizations": 15220,
	"./data/platform/partnership-organizations.json": 15220,
	"./data/platform/partnership-users": 38847,
	"./data/platform/partnership-users.json": 38847,
	"./data/platform/partnership.json": 86259,
	"./data/platform/partnerships": 65320,
	"./data/platform/partnerships.json": 65320,
	"./data/platform/partnershiptypes": 55472,
	"./data/platform/partnershiptypes.json": 55472,
	"./data/platform/permissions": 53181,
	"./data/platform/permissions.json": 53181,
	"./data/platform/permissions_full": 20079,
	"./data/platform/permissions_full.json": 20079,
	"./data/platform/projects-resources": 12051,
	"./data/platform/projects-resources-aws": 32577,
	"./data/platform/projects-resources-aws.json": 32577,
	"./data/platform/projects-resources-azure": 88146,
	"./data/platform/projects-resources-azure.json": 88146,
	"./data/platform/projects-resources-gcp": 49361,
	"./data/platform/projects-resources-gcp.json": 49361,
	"./data/platform/projects-resources-keystone": 71122,
	"./data/platform/projects-resources-keystone.json": 71122,
	"./data/platform/projects-resources-onprem": 30756,
	"./data/platform/projects-resources-onprem.json": 30756,
	"./data/platform/projects-resources.json": 12051,
	"./data/platform/ransomware-status": 87306,
	"./data/platform/ransomware-status.json": 87306,
	"./data/platform/ransomware-summary": 42801,
	"./data/platform/ransomware-summary.json": 42801,
	"./data/platform/registration-status": 23975,
	"./data/platform/registration-status.json": 23975,
	"./data/platform/resource-apac-get": 46172,
	"./data/platform/resource-apac-get.json": 46172,
	"./data/platform/resources": 73799,
	"./data/platform/resources.json": 73799,
	"./data/platform/roles": 41865,
	"./data/platform/roles.json": 41865,
	"./data/platform/s3": 42167,
	"./data/platform/s3.json": 42167,
	"./data/platform/saas-mp-service": 77020,
	"./data/platform/saas-mp-service.json": 77020,
	"./data/platform/self-certificate": 77369,
	"./data/platform/self-certificate.json": 77369,
	"./data/platform/settings-proxy": 91029,
	"./data/platform/settings-proxy.json": 91029,
	"./data/platform/signed-certificate": 3312,
	"./data/platform/signed-certificate.json": 3312,
	"./data/platform/snapcenter_clusters": 93635,
	"./data/platform/snapcenter_clusters.json": 93635,
	"./data/platform/snapshot-get": 19861,
	"./data/platform/snapshot-get.json": 19861,
	"./data/platform/storageAccounts": 69838,
	"./data/platform/storageAccounts.json": 69838,
	"./data/platform/subscriptions": 22763,
	"./data/platform/subscriptions.json": 22763,
	"./data/platform/support-services": 39837,
	"./data/platform/support-services.json": 39837,
	"./data/platform/system-about": 5478,
	"./data/platform/system-about.json": 5478,
	"./data/platform/tenancy-resources": 7571,
	"./data/platform/tenancy-resources.json": 7571,
	"./data/platform/tiering": 49712,
	"./data/platform/tiering.json": 49712,
	"./data/platform/uiroles": 92590,
	"./data/platform/uiroles.json": 92590,
	"./data/platform/user-details": 73650,
	"./data/platform/user-details-partner-org1": 67120,
	"./data/platform/user-details-partner-org1.json": 67120,
	"./data/platform/user-details.json": 73650,
	"./data/platform/user-details_full": 69378,
	"./data/platform/user-details_full.json": 69378,
	"./data/platform/user-details_org2": 19930,
	"./data/platform/user-details_org2.json": 19930,
	"./data/platform/user-login-tracking": 94318,
	"./data/platform/user-login-tracking.json": 94318,
	"./data/platform/user-permissions-resources": 21459,
	"./data/platform/user-permissions-resources.json": 21459,
	"./data/platform/user-preferences-app-preferences": 19900,
	"./data/platform/user-preferences-app-preferences.json": 19900,
	"./data/platform/user-preferences-splashscreen-v-1-dismissed": 86933,
	"./data/platform/user-preferences-splashscreen-v-1-dismissed.json": 86933,
	"./data/platform/user-resources-elevated-permissions": 71133,
	"./data/platform/user-resources-elevated-permissions.json": 71133,
	"./data/platform/user-resources-permissions": 31366,
	"./data/platform/user-resources-permissions.json": 31366,
	"./data/platform/users": 21075,
	"./data/platform/users-filter-service-account": 21266,
	"./data/platform/users-filter-service-account.json": 21266,
	"./data/platform/users-filter-total-users": 27021,
	"./data/platform/users-filter-total-users.json": 27021,
	"./data/platform/users.json": 21075,
	"./data/platform/view-volume-details": 72458,
	"./data/platform/view-volume-details.json": 72458,
	"./data/platform/working-environments": 34262,
	"./data/platform/working-environments-performance": 32874,
	"./data/platform/working-environments-performance.json": 32874,
	"./data/platform/working-environments.json": 34262,
	"./index": 91762,
	"./index.js": 91762,
	"./seeder": 58820,
	"./seeder.js": 58820,
	"./server": 86588,
	"./server.js": 86588,
	"./utils": 84148,
	"./utils.js": 84148,
	"./vars": 10056,
	"./vars.js": 10056,
	"./websocketServer": 42770,
	"./websocketServer.js": 42770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76771;